import React from 'react';
import termsNConditions from "../assets/Omnisource_TnC.pdf";

const TermsNConditions = () => {
  return (
    <embed src={termsNConditions} style={{
      height: "100vh",
      border: "none",
      width: "100%"
    }} />
  );
};

export default TermsNConditions;